import { Theme } from "@material-ui/core"
import FormControl from "@material-ui/core/FormControl"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import FormGroup from "@material-ui/core/FormGroup"
import Grid from "@material-ui/core/Grid"
import InputLabel from "@material-ui/core/InputLabel"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Switch from "@material-ui/core/Switch"
import TextField from "@material-ui/core/TextField"
import React from "react"
import FieldSelect from "Components/Table/FieldSelect"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import ContentTypeSelect from "../WeiboTool/ContentTypeSelect"
import DateSelect from "../WeiboTool/DateSelect"
import { useCreateMultipleWeibo } from "./hooks"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: "absolute",
        width: "100%",
        height: "100%",
    },
    timeBlock: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        marginTop: 20,
    },
    input: {
        width: "100%",
        marginTop: 10,
    },
}))

const WeiboMultipleCreate = () => {
    const classes = useStyles()
    const {
        callback, cancelCallback, dialogData,
        disabled, modalTimeStr, external,
        handleChangeDate, text, handleChange,
        handleChangeContentType,
        handleChangeLottery,
        handleChangeMicro,
        selectPlaceId,
        handleChangeArticleType,
    } = useCreateMultipleWeibo()
    return (
        <BoardConfirmModal
            title="创建预约"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <div className={classes.timeBlock}>
                <span>{modalTimeStr}</span>
                { selectPlaceId === 95 ? (
                    <DateSelect
                        hours={external.hours}
                        minutes={external.minutes}
                        onchange={handleChangeDate}/>
                ) : null }
            </div>
            <Grid item>
                <TextField
                    label="内容"
                    value={text}
                    onChange={handleChange}
                    className={classes.input}
                />
            </Grid>
            <Grid item>
                <FormControl className={classes.input}>
                    <InputLabel>内容形式</InputLabel>
                    <ContentTypeSelect onChange={handleChangeContentType}/>
                </FormControl>
            </Grid>
            <Grid item>
                <FormControl className={classes.input}>
                    <InputLabel >文章类型</InputLabel>
                    <FieldSelect
                        tableName="article_type"
                        onChange={handleChangeArticleType}
                        whereQuery={"where: {hidden: {_eq: false}}"}
                    />
                </FormControl>
            </Grid>
            <Grid item>
                <FormControl component="fieldset" className={classes.input}>
                    <FormGroup aria-label="position" row>
                        <FormControlLabel
                            value="抽奖"
                            control={
                                <Switch
                                    color="primary"
                                    checked={external.isLottery}
                                    onChange={handleChangeLottery}
                                />
                            }
                            label="抽奖"
                            labelPlacement="start"
                        />
                        <FormControlLabel
                            value="微任务"
                            control={
                                <Switch
                                    color="primary"
                                    checked={external.isMicro}
                                    onChange={handleChangeMicro}
                                />
                            }
                            label="微任务"
                            labelPlacement="start"
                        />
                    </FormGroup>
                </FormControl>
            </Grid>
        </BoardConfirmModal>
    )
}

export default WeiboMultipleCreate
